
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.71 16.56h-7.59A9.83 9.83 0 0013.29 11v8.38c-4.24 2.64-5.39 7.9-6.46 13H1.5c0 6.7.48 11.17 7 11.47a10.73 10.73 0 005.78 4.92v9h6.5L24.1 53h20.64v4.77h6.51a36.24 36.24 0 007.25-21.56c0-10.31-6.39-19.65-16.71-19.65h-3.28M14.28 33.27a2.95 2.95 0 115.89 0M26.81 21.47h14.74","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"34.18","cy":"10.17","r":"7.86","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    